
class AjaxError extends Error {
	#errorMessages;

	constructor(errorMessages = []) {
		super(errorMessages.join(', '));

		this.#errorMessages = errorMessages;
	}

	getErrorMessages() {
		return [...this.#errorMessages];
	}
}

export function fetchJson(...query) {
	return fetch(...query)
		.then(response => response.json())
		.then(({ success, ...rest }) => {
			if (success) {
				return rest.data;
			}
			throw new AjaxError(rest.errors)
		});
}
